import { Box, Typography } from '@mui/material';
import NumberFormat from 'react-number-format';

export enum ApplicationDetailsSummaryCoverSheetItemType {
  TotalAdults = 'TotalAdults',
  TotalChildren = 'TotalChildren',
  TotalPets = 'TotalPets',
  TotalVehicles = 'TotalVehicles',
  TotalIncome = 'TotalIncome',
  MoveInDate = 'MoveInDate',
}
export interface ApplicationDetailsSummaryCoverSheetItemTileProps {
  itemIconUrl: string;
  itemIconHeight: string;
  itemIconWidth: string;
  itemSubtitle: string;
  itemValue: string | number;
  itemType: ApplicationDetailsSummaryCoverSheetItemType;
}
export default function ApplicationDetailsSummaryCoverSheetItemTile(props: ApplicationDetailsSummaryCoverSheetItemTileProps) {
  return (
    <Box style={{ padding: 16, textAlign: 'center', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', height: '100px' }}>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'center' }}>
        <img src={props.itemIconUrl} alt="coversheet icon" style={{ width: props.itemIconWidth, height: props.itemIconHeight }} />
        <Typography sx={{ fontFamily: 'Work Sans !important' }}>{props.itemSubtitle}</Typography>
      </Box>
      <Box sx={{ marginLeft: '10px' }}>
        {props.itemType === ApplicationDetailsSummaryCoverSheetItemType.TotalIncome ? (
          <Typography sx={{ fontFamily: 'Work Sans !important', fontSize: '25px', fontWeight: 'bold' }}>
            <NumberFormat
              thousandsGroupStyle="thousand"
              value={props.itemValue as number} //will always be a number when its a total income
              prefix="$"
              decimalSeparator="."
              displayType="text"
              suffix="/month"
              type="text"
              thousandSeparator={true}
              allowNegative={true}
              decimalScale={0}
              fixedDecimalScale={true}
            />
          </Typography>
        ) : (
          <Typography sx={{ fontFamily: 'Work Sans !important', fontWeight: 'bold', fontSize: '25px' }}>{props.itemValue}</Typography>
        )}
      </Box>
    </Box>
  );
}
